import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/AuthContext';
import t from '../components/theme';

const BG_IMAGE = 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1920&q=80';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
        err?.response?.data?.error ||
        err?.message ||
        'Invalid credentials'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      {/* Background image */}
      <div style={styles.bgImage} />
      <div style={styles.bgOverlay} />

      {/* Google Fonts */}
      <link href={t.fontLink} rel="stylesheet" />

      <div style={styles.card}>
        <div style={styles.cardHeader}>
          <img
            src="/helena_logo_light.png"
            alt="Helena Partners"
            style={styles.logoImg}
          />
          <div style={styles.systemName}>PORTFOLIO MANAGEMENT SYSTEM</div>
        </div>

        <div style={styles.cardBody}>
          <p style={styles.subtitle}>Sign in to continue</p>

          <form onSubmit={handleSubmit} style={styles.form}>
            {error && <div style={styles.error}>{error}</div>}

            <label style={styles.label}>Username</label>
            <input
              style={styles.input}
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              required
            />

            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <button style={styles.button} type="submit" disabled={loading}>
              {loading ? 'Signing in\u2026' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    fontFamily: t.fontBody,
  },
  bgImage: {
    position: 'absolute',
    inset: 0,
    backgroundImage: `url(${BG_IMAGE})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  bgOverlay: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(135deg, rgba(44,40,37,0.55) 0%, rgba(44,40,37,0.35) 50%, rgba(44,40,37,0.55) 100%)',
  },
  card: {
    width: 420,
    background: 'rgba(255, 255, 255, 0.95)',
    borderRadius: t.radiusLg,
    border: `1px solid ${t.borderLight}`,
    boxShadow: '0 20px 60px rgba(44,40,37,0.25)',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 1,
    backdropFilter: 'blur(12px)',
  },
  cardHeader: {
    padding: '28px 36px 20px',
    borderBottom: `1px solid ${t.borderLight}`,
    textAlign: 'center',
    background: t.sidebar,
  },
  logoImg: {
    height: 36,
    objectFit: 'contain',
    marginBottom: 8,
  },
  systemName: {
    fontSize: 10,
    fontWeight: 600,
    color: t.sidebarActive,
    letterSpacing: '0.12em',
    fontFamily: t.fontBody,
  },
  cardBody: {
    padding: '24px 36px 36px',
  },
  subtitle: {
    textAlign: 'center',
    color: t.textMuted,
    fontSize: 14,
    marginTop: 0,
    marginBottom: 24,
    fontFamily: t.fontBody,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: 11,
    fontWeight: 600,
    color: t.textMuted,
    marginBottom: 6,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    fontFamily: t.fontBody,
  },
  input: {
    padding: '11px 14px',
    marginBottom: 18,
    borderRadius: t.radius,
    border: `1px solid ${t.border}`,
    background: t.bgInput,
    color: t.text,
    fontSize: 14,
    fontFamily: t.fontBody,
    outline: 'none',
    boxSizing: 'border-box',
    width: '100%',
  },
  button: {
    padding: '13px 0',
    borderRadius: t.radius,
    border: 'none',
    background: t.accent,
    color: t.textOnAccent,
    fontSize: 14,
    fontWeight: 700,
    cursor: 'pointer',
    marginTop: 4,
    letterSpacing: '0.02em',
    fontFamily: t.fontBody,
  },
  error: {
    background: t.dangerBg,
    border: `1px solid ${t.dangerBorder}`,
    color: t.danger,
    padding: '10px 14px',
    borderRadius: t.radius,
    fontSize: 13,
    marginBottom: 16,
  },
};
